module.exports = __webpack_public_path__ + "static/media/image-1.fc78c35e.jpg";